import React from "react";
import { FormControlLabel, Switch, Tooltip } from "@material-ui/core";
import SearchEngineToggleWrapper from "../styles/SearchEngineToggle.style";
import useWindow from "../../../hooks/useWindow";

const SearchEngineToggle = () => {
  const { isMobile } = useWindow(700);

  const [algoliaSearch, setAlgoliaSearch] = React.useState(
    localStorage.getItem("algoliaSearch") === "true"
  );

  const toggleSearchEngine = (isAlgoliaSearch) => {
    setAlgoliaSearch(isAlgoliaSearch);
    localStorage.setItem("algoliaSearch", isAlgoliaSearch);
    window.location.reload();
  };

  return (
    <SearchEngineToggleWrapper className="search-engine__wrapper">
      <Tooltip title={`AI search ${algoliaSearch ? "disabled" : "enabled"}`}>
        <FormControlLabel
          value="hide"
          label={`AI ${!isMobile ? "Search" : ""}`}
          labelPlacement="end"
          className="aisearch--toggle"
          control={
            <div className="switch--button">
              <Switch
                color="primary"
                className={`switch ${!algoliaSearch ? "toggle-on" : "toggle-off"}`}
                checked={!algoliaSearch}
                onChange={(event, checked) => toggleSearchEngine(!checked)}
              />
            </div>
          }
        />
      </Tooltip>
    </SearchEngineToggleWrapper>
  );
};

export default SearchEngineToggle;
